import { template as template_810deb60bdb34c0baa175adbf3282345 } from "@ember/template-compiler";
import Component from '@glimmer/component';
/**
  Renders a `<tr>` element and yields cell component.
  ```hbs
  <table.tfoot as |foot|>
    <foot.row as |row|>
      <row.cell>
        Footer content
      </row.cell>
    </foot.row>
  </table.tfoot>
  ```

  @class TFootRow
  @yield {object} row
  @yield {Component} row.cell
*/ import { hash } from '@ember/helper';
import Cell from './row/cell.gjs';
export default class TFootRow extends Component {
    static{
        template_810deb60bdb34c0baa175adbf3282345(`
    <tr class='{{@class}} {{@theme.tfootRow}} {{@theme.row}}' ...attributes>
      {{yield (hash cell=(component Cell theme=@theme parent=this columns=@columns))}}
    </tr>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    cells = [];
    registerCell(cell) {
        let index = this.cells.length;
        this.cells.push(cell);
        return index;
    }
    unregisterCell(cell) {
        let cells = this.cells;
        let index = cells.indexOf(cell);
        cells.splice(index, 1);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9taWd1ZWwvd29ya3NwYWNlL2VtYmVyLXlldGktdGFibGUvZW1iZXIteWV0aS10YWJsZS9zcmMvY29tcG9uZW50cy95ZXRpLXRhYmxlL3Rmb290L3Jvdy5nanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IENvbXBvbmVudCBmcm9tICdAZ2xpbW1lci9jb21wb25lbnQnO1xuXG4vKipcbiAgUmVuZGVycyBhIGA8dHI-YCBlbGVtZW50IGFuZCB5aWVsZHMgY2VsbCBjb21wb25lbnQuXG4gIGBgYGhic1xuICA8dGFibGUudGZvb3QgYXMgfGZvb3R8PlxuICAgIDxmb290LnJvdyBhcyB8cm93fD5cbiAgICAgIDxyb3cuY2VsbD5cbiAgICAgICAgRm9vdGVyIGNvbnRlbnRcbiAgICAgIDwvcm93LmNlbGw-XG4gICAgPC9mb290LnJvdz5cbiAgPC90YWJsZS50Zm9vdD5cbiAgYGBgXG5cbiAgQGNsYXNzIFRGb290Um93XG4gIEB5aWVsZCB7b2JqZWN0fSByb3dcbiAgQHlpZWxkIHtDb21wb25lbnR9IHJvdy5jZWxsXG4qL1xuXG5pbXBvcnQgeyBoYXNoIH0gZnJvbSAnQGVtYmVyL2hlbHBlcic7XG5pbXBvcnQgQ2VsbCBmcm9tICcuL3Jvdy9jZWxsLmdqcyc7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFRGb290Um93IGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgPHRlbXBsYXRlPlxuICAgIDx0ciBjbGFzcz0ne3tAY2xhc3N9fSB7e0B0aGVtZS50Zm9vdFJvd319IHt7QHRoZW1lLnJvd319JyAuLi5hdHRyaWJ1dGVzPlxuICAgICAge3t5aWVsZCAoaGFzaCBjZWxsPShjb21wb25lbnQgQ2VsbCB0aGVtZT1AdGhlbWUgcGFyZW50PXRoaXMgY29sdW1ucz1AY29sdW1ucykpfX1cbiAgICA8L3RyPlxuICA8L3RlbXBsYXRlPlxuICBjZWxscyA9IFtdO1xuXG4gIHJlZ2lzdGVyQ2VsbChjZWxsKSB7XG4gICAgbGV0IGluZGV4ID0gdGhpcy5jZWxscy5sZW5ndGg7XG4gICAgdGhpcy5jZWxscy5wdXNoKGNlbGwpO1xuICAgIHJldHVybiBpbmRleDtcbiAgfVxuXG4gIHVucmVnaXN0ZXJDZWxsKGNlbGwpIHtcbiAgICBsZXQgY2VsbHMgPSB0aGlzLmNlbGxzO1xuICAgIGxldCBpbmRleCA9IGNlbGxzLmluZGV4T2YoY2VsbCk7XG4gICAgY2VsbHMuc3BsaWNlKGluZGV4LCAxKTtcbiAgfVxufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLGVBQWUscUJBQXFCO0FBRTNDOzs7Ozs7Ozs7Ozs7Ozs7QUFlQSxHQUVBLFNBQVMsSUFBSSxRQUFRLGdCQUFnQjtBQUNyQyxPQUFPLFVBQVUsaUJBQWlCO0FBRWxDLGVBQWUsTUFBTSxpQkFBaUI7SUFDcEMsTUFBQTtRQUFBLDBDQUFVLENBQUE7Ozs7RUFJVixDQUFBLEVBQUE7WUFBQSxXQUFBLElBQVc7WUFBWDtnQkFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7WUFBRDtRQUFBO0lBQUEsQ0FKQTtJQUtWLFFBQVEsRUFBRSxDQUFDO0lBRVgsYUFBYSxJQUFJLEVBQUU7UUFDakIsSUFBSSxRQUFRLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTTtRQUM3QixJQUFJLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQztRQUNoQixPQUFPO0lBQ1Q7SUFFQSxlQUFlLElBQUksRUFBRTtRQUNuQixJQUFJLFFBQVEsSUFBSSxDQUFDLEtBQUs7UUFDdEIsSUFBSSxRQUFRLE1BQU0sT0FBTyxDQUFDO1FBQzFCLE1BQU0sTUFBTSxDQUFDLE9BQU87SUFDdEI7QUFDRiJ9